import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridsterModule } from 'angular-gridster2'


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    GridsterModule
  ]
})
export class PluginModule { }
